/**
 * Santa Eulalia - Tailoring Appointment Form (v2 — slot picker)
 * Auto-generated asset uploaded via Shopify API.
 * Do NOT edit directly in Shopify — changes will be overwritten on next publish.
 *
 * Mirror of groom_form.js but targets #form-tailoring. Reuses window.groomConfig
 * because tailoring shares the same slot group as groom in Portal.
 */
(function () {
  // Flag to prevent custom.js legacy tailoring handler from interfering
  window.__tailoringFormV2 = true;

  function init() {
    if (typeof $ === 'undefined' || typeof flatpickr === 'undefined' || typeof Pristine === 'undefined') {
      setTimeout(init, 100);
      return;
    }

    var formTailoring = $('#form-tailoring');
    if (!formTailoring.length) return;

    // --- helpers ---
    async function postData(url, data) {
      try {
        var response = await fetch(url, {
          method: 'POST', mode: 'cors', cache: 'no-cache', credentials: 'omit',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json;charset=utf-8', 'Access-Control-Allow-Origin': '*' },
          redirect: 'follow', referrerPolicy: 'no-referrer',
          body: JSON.stringify(data)
        });
        return await response.json();
      } catch (error) { console.log('postData error', error); }
    }

    function showServerError(msg) {
      var old = document.getElementById('server-error');
      if (old) old.remove();
      var el = document.createElement('div');
      el.id = 'server-error';
      el.className = 'pristine-error text-help';
      el.setAttribute('role', 'alert');
      el.style.display = 'block';
      el.style.marginTop = '8px';
      el.style.marginBottom = '8px';
      el.style.fontSize = '14px';
      el.textContent = msg;
      var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (submitBtn) {
        submitBtn.parentNode.insertBefore(el, submitBtn);
      } else {
        form.appendChild(el);
      }
    }

    // --- setup ---
    var closedDaysLegacy = $('#tailoring-info-hidde #not_available_tailoring').val();
    var langform = document.getElementById('lang').dataset.language;
    var form = document.getElementById('form-tailoring');
    var pristine = new Pristine(form);

    // Closed days: config + legacy
    var closedFromConfig = window.groomConfig && window.groomConfig.closed_days ? window.groomConfig.closed_days : [];
    var closedFromLegacy = closedDaysLegacy ? closedDaysLegacy.split(',') : [];
    var allClosedDays = closedFromConfig.concat(closedFromLegacy).filter(function (v, i, a) { return a.indexOf(v) === i; });

    // Full days: dates where all appointment slots are taken
    var fullDays = window.groomConfig && window.groomConfig.full_days ? window.groomConfig.full_days : [];

    // Full ranges: per-date list of time ranges that are fully booked
    var fullRanges = window.groomConfig && window.groomConfig.full_ranges ? window.groomConfig.full_ranges : {};

    function pad2(n) { return String(n).padStart(2, '0'); }

    function formatDate(d) {
      return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
    }

    // --- Get time ranges for a specific date ---
    function getRangesForDate(dateStr) {
      var d = new Date(dateStr + 'T12:00:00');
      var dayOfWeek = d.getDay();
      var isoDow = dayOfWeek === 0 ? 7 : dayOfWeek;

      var overrides = window.groomSlotByDayConfig && window.groomSlotByDayConfig.dateOverrides;
      var dateOverride = overrides ? overrides[dateStr] : null;
      if (dateOverride && dateOverride.closed) return [];

      return (dateOverride && dateOverride.timeRanges)
        || (window.groomConfig && window.groomConfig.timeRangesByWeekday && window.groomConfig.timeRangesByWeekday[isoDow])
        || [];
    }

    // --- Check if a time range is fully booked for a date ---
    function isRangeFull(dateStr, rangeStart, rangeEnd) {
      var dateFullRanges = fullRanges[dateStr];
      if (!dateFullRanges) return false;
      for (var i = 0; i < dateFullRanges.length; i++) {
        if (dateFullRanges[i].start === rangeStart && dateFullRanges[i].end === rangeEnd) {
          return true;
        }
      }
      return false;
    }

    // --- Generate individual 15-min slots from ranges ---
    function generateSlots(dateStr, ranges) {
      var slots = [];
      var appointments = (window.groomConfig && window.groomConfig.currentAppointments) || {};

      for (var i = 0; i < ranges.length; i++) {
        var range = ranges[i];
        var rangeFull = isRangeFull(dateStr, range.start, range.end);
        var startParts = range.start.split(':');
        var endParts = range.end.split(':');
        var startMin = parseInt(startParts[0]) * 60 + parseInt(startParts[1]);
        var endMin = parseInt(endParts[0]) * 60 + parseInt(endParts[1]);

        for (var m = startMin; m < endMin; m += 15) {
          var hh = pad2(Math.floor(m / 60));
          var mm = pad2(m % 60);
          var time = hh + ':' + mm;
          var key = dateStr + ' ' + time;
          var occupied = appointments[key] || 0;
          var capacity = range.capacity != null ? range.capacity : 1;
          slots.push({
            time: time,
            label: hh + ':' + mm,
            available: !rangeFull && occupied < capacity
          });
        }
      }
      return slots;
    }

    // --- State ---
    var selectedDate = null;
    var selectedTime = null;
    var hiddenInput = document.getElementById('appointment-date');
    var slotsWrapper = document.getElementById('tailoring-slots-wrapper');
    var slotsGrid = document.getElementById('tailoring-slots-grid');

    // --- Render slot grid ---
    function renderSlots(dateStr) {
      var ranges = getRangesForDate(dateStr);
      var slots = generateSlots(dateStr, ranges);

      slotsGrid.innerHTML = '';
      selectedTime = null;
      hiddenInput.value = '';

      // Clear any previous error
      var oldErr = document.getElementById('slot-error');
      if (oldErr) oldErr.remove();

      if (slots.length === 0) {
        slotsWrapper.style.display = 'none';
        return;
      }

      for (var i = 0; i < slots.length; i++) {
        (function (slot) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'groom-slot-btn' + (slot.available ? '' : ' disabled');
          btn.textContent = slot.label;
          btn.setAttribute('data-time', slot.time);
          if (!slot.available) {
            btn.disabled = true;
          }
          btn.addEventListener('click', function () {
            if (!slot.available) return;
            // Deselect previous
            var prev = slotsGrid.querySelector('.groom-slot-btn.active');
            if (prev) prev.classList.remove('active');
            // Select this
            this.classList.add('active');
            selectedTime = slot.time;
            hiddenInput.value = selectedDate + ' ' + selectedTime;
            // Clear any validation error
            var err = document.getElementById('slot-error');
            if (err) err.remove();
          });
          slotsGrid.appendChild(btn);
        })(slots[i]);
      }

      slotsWrapper.style.display = '';
    }

    // --- Flatpickr (date only) on the VISIBLE input ---
    flatpickr('#appointment-date-picker', {
      locale: langform,
      enableTime: false,
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'F j, Y',
      minDate: new Date(Date.now() + 2 * 86400000),
      maxDate: new Date(Date.now() + 62 * 86400000),
      disable: [
        function (date) {
          var dateStr = formatDate(date);
          if (allClosedDays.indexOf(dateStr) !== -1) return true;
          if (fullDays.indexOf(dateStr) !== -1) return true;

          var isoDow = date.getDay() === 0 ? 7 : date.getDay();
          var weekdaySlots = window.groomConfig && window.groomConfig.timeRangesByWeekday
            ? window.groomConfig.timeRangesByWeekday[isoDow] || []
            : [];
          var hasSlots = weekdaySlots.length > 0;

          var overrides = window.groomSlotByDayConfig && window.groomSlotByDayConfig.dateOverrides;
          var dateOverride = overrides ? overrides[dateStr] : null;
          if (dateOverride && dateOverride.closed === true) return true;

          // If override has timeRanges and ALL have capacity 0, treat as closed
          if (dateOverride && dateOverride.timeRanges && dateOverride.timeRanges.length > 0) {
            var allZero = dateOverride.timeRanges.every(function (r) { return r.capacity === 0; });
            if (allZero) return true;
          }

          return !hasSlots && !dateOverride;
        }
      ],
      onChange: function (selectedDates) {
        if (!selectedDates[0]) return;
        selectedDate = formatDate(selectedDates[0]);
        renderSlots(selectedDate);
      }
    });

    // --- Neutralize custom.js: destroy any flatpickr it creates on #appointment-date ---
    var cleanupCount = 0;
    var cleanupInterval = setInterval(function () {
      var el = document.getElementById('appointment-date');
      if (el && el._flatpickr) {
        el._flatpickr.destroy();
        clearInterval(cleanupInterval);
      }
      if (++cleanupCount > 30) clearInterval(cleanupInterval);
    }, 200);

    // --- Submit handler (with stopImmediatePropagation to block custom.js handler) ---
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var oldServerError = document.getElementById('server-error');
      if (oldServerError) oldServerError.remove();

      var dateTimeVal = hiddenInput.value;

      // Validate: date + time slot must be selected
      if (!dateTimeVal || dateTimeVal.indexOf(' ') === -1) {
        var noSlotMsg = {
          ca: 'Selecciona si us plau una data i un horari.',
          es: 'Selecciona por favor una fecha y un horario.',
          en: 'Please select a date and a time slot.'
        };
        var locale = typeof Shopify !== 'undefined' ? Shopify.locale : 'en';

        // Show error near the date picker
        var old = document.getElementById('slot-error');
        if (old) old.remove();
        var errEl = document.createElement('div');
        errEl.id = 'slot-error';
        errEl.className = 'pristine-error text-help';
        errEl.style.display = 'block';
        errEl.style.marginTop = '4px';
        errEl.textContent = noSlotMsg[locale] || noSlotMsg.en;
        var datePickerField = document.getElementById('appointment-date-picker');
        if (datePickerField) {
          datePickerField.closest('.field.form-group').appendChild(errEl);
        }
        return;
      }

      if (pristine.validate()) {
        var data = {
          locale: typeof Shopify !== 'undefined' ? Shopify.locale : 'es',
          name: form.querySelector('#name').value,
          lastname: form.querySelector('#lastname').value,
          email: form.querySelector('#email').value,
          phone: form.querySelector('#phone').value,
          date: hiddenInput.value,
          hearaboutus: form.querySelector('#hearaboutus').value,
          comments: form.querySelector('#comment').value
        };

        var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        postData($('#tailoring-info-hidde #general_url').val() + '/tailoring', data).then(function (result) {
          if (result && result.status === 'ok') {
            pristine.reset();
            form.reset();
            slotsWrapper.style.display = 'none';
            slotsGrid.innerHTML = '';
            window.location.replace($('#tailoring-info-hidde #tailoring_success').val());
          } else if (result && result.status === 'error') {
            showServerError(result.message);
            if (submitBtn) submitBtn.disabled = false;
          } else {
            window.location.replace($('#tailoring-info-hidde #tailoring_error').val());
          }
        }).catch(function () {
          window.location.replace($('#tailoring-info-hidde #tailoring_error').val());
        });
      }
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
